import { render, staticRenderFns } from "./VendorInventoryPreviousOrdersCell.vue?vue&type=template&id=cbfda426"
import script from "./VendorInventoryPreviousOrdersCell.vue?vue&type=script&lang=js"
export * from "./VendorInventoryPreviousOrdersCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports